var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkamai({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1.033 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7971D",
    d: "M17.764 17.574h-2.268l2.078-4.156.19 4.156zm.19 1.891l.189 1.7h2.645l-.945-9.637h-3.969l-4.913 9.637h2.645l.758-1.7h3.59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0095D6",
    d: "M12.094 23.433c-4.913-1.512-8.503-6.047-8.503-11.338 0-5.48 3.59-10.013 8.692-11.528.567-.189.379-.567-.189-.567C5.288.188 0 5.48 0 12.094 0 18.709 5.288 24 12.094 24c.569 0 .569-.378 0-.567zM5.858 14.74v-.944c0-5.288 4.158-9.45 9.449-9.45 4.914 0 6.426 2.268 6.615 2.079.188-.188-1.701-4.535-7.559-4.535-5.288 0-9.45 4.158-9.45 9.449 0 1.134.189 2.268.567 3.401.19.567.379.567.378 0zm3.97-6.803c2.456-1.134 5.479-1.134 8.503 0 2.078.756 3.213 1.701 3.402 1.701s-1.135-2.268-3.592-3.213c-3.021-1.137-6.047-.562-8.503 1.323-.189.189 0 .377.19.189z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkamai);
export default __webpack_public_path__ + "static/media/akamai.3933a452a9f5c04ddb85cdde43258f37.svg";
export { ForwardRef as ReactComponent };